import React, { Component } from 'react';
import perfil from '../bn.png';
import Leftbar from '../components/Leftbar';

class About extends Component {
    render() {
        return (
            <>
                <Leftbar />
                <div className="container min-100">
                    <div className="row main-section justify-content-md-center align-items-center">
                        <div className="col photo-col">
                            <img src={perfil} className="photo-img" alt="perfil-img" />
                        </div>
                        <div className="col">
                            <h2>About Me</h2>
                            <p> Here a few technologies I've been working with recently:</p>
                            <ul>
                                <li>Javascript / ReactJS</li>
                                <li>Bootstrap</li>
                                <li>PHP / Laravel</li>
                                <li>Wordpress</li>
                                <li>D3</li>
                            </ul>
                            <p>I'm Currently focused on using ReactJS to create fast and responsive website.</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default About;